var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo, useState } from 'react';
import useCommonProps from './useCommonProps';
var FILE_EXTENSION_REGEXP = /(?:\.([^.]+))?$/;
var useResizedPostImage = function (post, containerRef, isVotePost) {
    var _a = useState(), container = _a[0], setContainer = _a[1];
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var containerWidth = container === null || container === void 0 ? void 0 : container.offsetWidth;
    var targetSize = containerWidth * pixelRatio;
    var showOriginals = useCommonProps().showOriginals;
    useEffect(function () {
        setContainer(containerRef.current);
    }, [containerRef.current]);
    return useMemo(function () {
        var _a;
        var attachment = post.attachments[0];
        if (attachment && targetSize) {
            if (isVotePost) {
                var res_1 = [];
                (_a = post.attachments) === null || _a === void 0 ? void 0 : _a.forEach(function (f) {
                    var preview = f.file, _a = f.files, files = _a === void 0 ? [] : _a;
                    var sorted = __spreadArray([], files, true).sort(function (a, b) { return a.width - b.width; });
                    var resizedFile = sorted.find(function (_a) {
                        var width = _a.width;
                        return width >= targetSize;
                    });
                    var largest = sorted.reduce(function (result, item) {
                        var width = item.width, height = item.height;
                        var area = width * height;
                        var largestArea = result.largestArea;
                        if (!largestArea || area > largestArea) {
                            return {
                                largest: item,
                                largestArea: area
                            };
                        }
                        return result;
                    }, {
                        largestArea: 0,
                        largest: null
                    }).largest;
                    var original = largest || preview;
                    var _b = FILE_EXTENSION_REGEXP.exec(original === null || original === void 0 ? void 0 : original.url), ext = _b[1];
                    var isGif = ext === 'gif';
                    var resized = isGif ? original : resizedFile || original;
                    res_1.push([original, resized]);
                });
                return res_1;
            }
            var preview = attachment.file, _b = attachment.files, files = _b === void 0 ? [] : _b;
            var sorted = __spreadArray([], files, true).sort(function (a, b) { return a.width - b.width; });
            var resizedFile = sorted.find(function (_a) {
                var width = _a.width;
                return width >= targetSize;
            });
            var largest = sorted.reduce(function (result, item) {
                var width = item.width, height = item.height;
                var area = width * height;
                var largestArea = result.largestArea;
                if (!largestArea || area > largestArea) {
                    return {
                        largest: item,
                        largestArea: area
                    };
                }
                return result;
            }, {
                largestArea: 0,
                largest: null
            }).largest;
            var original = largest || preview;
            var _c = FILE_EXTENSION_REGEXP.exec(original === null || original === void 0 ? void 0 : original.url), ext = _c[1];
            var isGif = ext === 'gif';
            var resized = isGif || showOriginals ? original : resizedFile || original;
            return [original, resized];
        }
        return [];
    }, [post, targetSize, showOriginals]);
};
export default useResizedPostImage;
//# sourceMappingURL=useResizedPostImage.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo, useState } from 'react';
import useCommonProps from './useCommonProps';
var FILE_EXTENSION_REGEXP = /(?:\.([^.]+))?$/;
var useResizedPostImage = function (post, containerRef, isVotePost) {
    var _a = useState(), container = _a[0], setContainer = _a[1];
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var containerWidth = container === null || container === void 0 ? void 0 : container.offsetWidth;
    var targetSize = containerWidth * pixelRatio;
    var showOriginals = useCommonProps().showOriginals;
    useEffect(function () {
        setContainer(containerRef.current);
    }, [containerRef.current]);
    return useMemo(function () {
        var _a;
        var attachment = post.attachments[0];
        if (attachment && targetSize) {
            if (isVotePost) {
                var res_1 = [];
                (_a = post.attachments) === null || _a === void 0 ? void 0 : _a.forEach(function (f) {
                    var preview = f.file, _a = f.files, files = _a === void 0 ? [] : _a;
                    var sorted = __spreadArray([], files, true).sort(function (a, b) { return a.width - b.width; });
                    var resizedFile = sorted.find(function (_a) {
                        var width = _a.width;
                        return width >= targetSize;
                    });
                    var largest = sorted.reduce(function (result, item) {
                        var width = item.width, height = item.height;
                        var area = width * height;
                        var largestArea = result.largestArea;
                        if (!largestArea || area > largestArea) {
                            return {
                                largest: item,
                                largestArea: area
                            };
                        }
                        return result;
                    }, {
                        largestArea: 0,
                        largest: null
                    }).largest;
                    var original = largest || preview;
                    var _b = FILE_EXTENSION_REGEXP.exec(original === null || original === void 0 ? void 0 : original.url), ext = _b[1];
                    var isGif = ext === 'gif';
                    var resized = isGif ? original : resizedFile || original;
                    res_1.push([original, resized]);
                });
                return res_1;
            }
            var preview = attachment.file, _b = attachment.files, files = _b === void 0 ? [] : _b;
            var sorted = __spreadArray([], files, true).sort(function (a, b) { return a.width - b.width; });
            var resizedFile = sorted.find(function (_a) {
                var width = _a.width;
                return width >= targetSize;
            });
            var largest = sorted.reduce(function (result, item) {
                var width = item.width, height = item.height;
                var area = width * height;
                var largestArea = result.largestArea;
                if (!largestArea || area > largestArea) {
                    return {
                        largest: item,
                        largestArea: area
                    };
                }
                return result;
            }, {
                largestArea: 0,
                largest: null
            }).largest;
            var original = largest || preview;
            var _c = FILE_EXTENSION_REGEXP.exec(original === null || original === void 0 ? void 0 : original.url), ext = _c[1];
            var isGif = ext === 'gif';
            var resized = isGif || showOriginals ? original : resizedFile || original;
            return [original, resized];
        }
        return [];
    }, [post, targetSize, showOriginals]);
};
export default useResizedPostImage;
//# sourceMappingURL=useResizedPostImage.js.map